const de = {
  app: {
    label: {
      true: 'Ja',
      false: 'Nein',
    },
    loginWidget: {
      email: 'E-Mail',
      forgotPassword: 'Passwort vergessen?',
      login: 'Einloggen',
      loginWelcome:
        'Willkommen zurück. Loggen Sie sich mit Ihren Nutzerdaten ein.',
      next: 'Weiter',
      password: 'Passwort',
      title: 'Login',
    },
    resetWidget: {
      title: 'Passwort vergessen?',
      instructions:
        'Bitte geben Sie die E-Mail Adresse ihres Accounts ein. Wir werden Ihnen Instruktionen zum Zurücksetzen zusenden.',
      emailLabel: 'Email Adresse',
      emailPlaceholder: 'Geben Sie Ihre E-Mail Adresse ein',
      back: 'Zurück zum Login',
      submit: 'Abschicken',
      submitSso: 'Zum Single Sign-on portal',
    },
    resetConfirmationWidget: {
      title: 'Neues Passwort wurde angefragt',
      confirmation:
        'Bitte prüfen Sie ihr E-Mail Postfach für weitere Instruktionen',
      back: 'Zurück zum Login',
    },
    changePasswordWidget: {
      title: 'Passwort setzen',
      forcedTitle: 'Passwort zurücksetzen',
      info: 'Setzen Sie ihr neues persönliches Passwort unter Beachtung unserer Sicherheitsempfehlungen',
      placeholder: 'Passwort',
      newPasswordLabel: 'Geben Sie ihr neues Passwort ein',
      confirmationLabel: 'Wiederholen Sie ihr neues Passwort',
      confirmationError:
        'Die Passwortwiederholung stimmt nicht mit dem Passwort überein',
      backToLogin: 'Zum Login',
      back: 'Zurück',
      submit: 'Passwort setzen',
      recommendations: {
        characterCount: 'min. 10 Zeichen',
        containing: 'beinhaltend',
      },
    },
    logout: 'Abmelden',
    inactivityLogout:
      'Sie wurden aus Sicherheitsgründen aufgrund von Inaktivität ausgeloggt. Loggen Sie sich mit Ihren Nutzerdaten bitte erneut ein.',
    changePassword: 'Passwort ändern',
    switchToLightTheme: 'Wechsel zur hellen Oberfläche',
    switchToDarkTheme: 'Wechsel zur dunklen Oberfläche',
    page: {
      genericError: 'Es ist ein Fehler aufgetreten',
      retry: 'Neu laden',
      notLoadedTitle: 'Die Seite konnte nicht geladen werden',
      notLoadedErrorText:
        'Die gesuchte Seite existiert nicht, oder es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, oder kontaktieren Sie Ihren Administrator.',
      pageContentErrorTitle: 'Fehler beim Seiteninhalt',
      contentNotFoundError:
        'Beim Laden des Inhalts ist ein Problem aufgetreten.  Bitte aktualisieren Sie die Seite oder versuchen Sie es später noch einmal.',
      backToDashboard: 'Zurück zum Dashboard',
      close: 'Detailsseite schließen',
    },
    pageFilter: {
      placeholder: 'Alle',
      reset: 'Filter zurücksetzen',
      calendarFilter: {
        defaultTitle: 'Datum',
        placeholder: 'Datum auswählen',
      },
      dateRangeFilter: {
        placeholderFrom: 'Von',
        placeholderTo: 'Bis',
      },
    },
    pagination: {
      summary:
        '{{firstShownEntry}} - {{lastShownEntry}} von {{totalEntries}} Einträgen',
      summaryShort: '{{totalEntries}} von {{totalEntries}} Einträgen',
      selectItem: '{{entries}} pro Seite',
      selectedRows: '{{selectedRowsCount}} ausgewählt',
      entryLimit: ' (auf {{totalEntries}} Einträge begrenzt)',
    },
    table: {
      tooltip: {
        maliciousContent:
          'Unsere Prüfung hat ergeben, dass diese Datei potentiell schädliche Inhalte hat.',
      },
      searchResultPagination:
        '{{shownResults}} von {{totalResults}} Ergebnissen',
      customizationModal: {
        title: 'Tabelleneinstellungen',
        divider: 'Bewegen Sie fixierte Spalten über diese Linie',
        resetChanges: 'Alle Änderungen zurücksetzen',
        cancel: 'Abbrechen',
        apply: 'Speichern & Schließen',
        selectAll: 'Alle auswählen',
      },
      filterModal: {
        title: 'Filter hinzufügen',
        resetChanges: 'Alle Filter löschen',
        cancel: 'Abbrechen',
        apply: 'Speichern & Schließen',
        selectAll: 'Alle auswählen',
      },
      showMoreEntry_one: '+ {{ count }} Eintrag mehr',
      showMoreEntry_other: '+ {{ count }} Einträge mehr',
      workflowActionModal: {
        apply: 'Bestätigen',
        cancel: 'Abbrechen',
        close: 'Schließen',
        successMessage: 'Die Aktion wurde erfolgreich ausgeführt.',
        fileUploadRequired: 'Es muss mindestens eine Datei ausgewählt werden.',
        actionSuccessfulCountTimes_one:
          'Die Aktion wurde für {{ count }} Element erfolgreich ausgeführt,',
        actionSuccessfulCountTimes_other:
          'Die Aktion wurde für {{ count }} Elemente erfolgreich ausgeführt,',
        actionFailedCountTimes_one:
          'ist aber für {{ count }} Element gescheitert',
        actionFailedCountTimes_other:
          'ist aber für {{ count }} Elemente gescheitert',
      },
      documentSigning: {
        initializationErrorNotification:
          'Es ist ein Fehler während der Initialisierung der Dokumentensignierung aufgetreten',
        finalizingErrorNotification:
          'Es ist ein Fehler während der Finalisierung der Dokumentensignierung aufgetreten',
        finalizingNotification: 'Finalisiere Dokumentensignierung',
        successNotification: 'Die Dokumentensignierung war erfolgreich',
      },
      deleteConfirmation: {
        cancel: 'Abbrechen',
        apply: 'Löschen',
        title: 'Löschen',
        message_one: 'Möchten Sie wirklich {{count}} Dokument löschen?',
        message_other: 'Möchten Sie wirklich {{count}} Dokumente löschen?',
      },
    },
    datepicker: {
      qtd: 'Dieses Quartal',
      qtdShort: 'QTD',
      ytd: 'Dieses Jahr',
      ytdShort: 'YTD',
      ltm: 'Letzten zwölf Monate',
      ltmShort: 'LTM',
      sinceInception: 'Alle Tage bis heute',
      sinceInceptionShort: 'Seit Einführung',
    },
    select: {
      noOptionsAvailable: 'Keine Optionen verfügbar',
      noOptionsFound: "Keine Optionen für '{{query}}'",
      selectAbove: 'Gelistete Optionen selektieren',
    },
    search: {
      placeholder: 'Suche',
    },
    noAccessError: {
      headline: 'Fehlende Berechtigungen',
      body: 'Sie benötigen zusätzliche Zugriffsrechte, um diese Anwendung nutzen zu können.',
      resolution:
        'Tritt dieser Fehler unerwartet auf, kontaktieren Sie bitte Ihren Support Ansprechpartner.',
      logoutButton: 'Abmelden',
    },
    notifications: {
      goToPage: 'Gehe zu Seite',
      excelExport: {
        error:
          'Daten <0>({{fileName}})</0> für Excel konnten nicht erfolgreich heruntergeladen werden.',
        loading: 'Erstelle Daten <0>({{fileName}})</0> für Excel.',
        success:
          'Daten <0>({{fileName}})</0> für Excel wurden erfolgreich heruntergeladen.',
      },
      bulkDownload: {
        error: 'Downloadarchiv konnte nicht erstellt werden.',
        loading_one: 'Erstelle Downloadarchiv für {{count}} Dokument.',
        loading_other: 'Erstelle Downloadarchiv für {{count}} Dokumente.',
        success_one: 'Starte Download von Archiv für {{count}} Dokument.',
        success_other: 'Starte Download von Archiv für {{count}} Dokumente.',
      },
      downloadRow: {
        error: 'Tabellendaten konnten nicht geladen werden',
        loading_one: 'Lade Daten für {{count}} Zeile',
        loading_other: 'Lade Daten für {{count}} Zeilen',
        success_one: 'Starte Download der Daten für {{count}} Zeile',
        success_other: 'Starte Download der Daten für {{count}} Zeilen',
      },
      rowRequest: {
        error: 'Anfrage konnte nicht gesendet werden',
        loading_one: 'Sende Anfrage für {{count}} Zeile',
        loading_other: 'Sende Anfrage für {{count}} Zeilen',
        success_one: 'Anfrage für {{count}} Zeile erfolgreich gesendet',
        success_other: 'Anfrage für {{count}} Zeilen erfolgreich gesendet',
      },
      markAsRead: {
        error: 'Dokumente als gelesen markieren ist fehlgeschlagen.',
        success:
          '{{count}} Dokument(e) wurden erfolgreich als gelesen markiert.',
      },
      markAsUnread: {
        error: 'Dokumente als ungelesen markieren ist fehlgeschlagen.',
        success:
          '{{count}} Dokument(e) wurden erfolgreich als ungelesen markiert.',
      },
      delete: {
        error: 'Dokumente löschen ist fehlgeschlagen.',
        success: '{{count}} Dokument(e) wurden erfolgreich gelöscht.',
      },
    },
    dataRefresh: {
      label: 'Letzte Datenaktualisierung',
      tooltip: 'Letzte Datenaktualisierung: {{formattedDate}}',
    },
    disclaimer: {
      accept: 'Ich stimme zu',
      cancel: 'Abbrechen',
      defaultTitle: 'Disclaimer',
    },
    widget: {
      action: {
        label: {
          additionalInformation: 'Weiterführende Informationen',
          bulkActions: 'Weitere Aktionen',
          closeFullscreen: 'Vollbildmodus beenden',
          customFilter: 'Tabellenfilter konfigurieren',
          customization: 'Tabelle konfigurieren',
          delete: 'Löschen',
          download: 'Download Dokumente',
          edit: 'Bearbeiten',
          excelDownloadFiltered: 'Gefilterte Daten für Excel herunterladen',
          excelDownloadReadOnly:
            'Schreibgeschützte Daten für Excel herunterladen',
          excelDownloadUnFiltered: 'Alle Daten für Excel herunterladen',
          imageDownload: 'Als Bild exportieren',
          imageDownloadWithBackground: 'Als Bild mit Hintergrund exportieren',
          initFoundOperation: 'Fund Operation erstellen',
          markAsRead: 'Als gelesen markieren',
          markAsUnread: 'Als ungelesen markieren',
          openInFullscreen: 'Im Vollbildmodus öffnen',
          shareActions: 'Daten exportieren',
          createRow: 'Zeile erstellen',
          openDetailPage: 'Öffne Details für {{label}}',
        },
        tooltip: {
          excelDownloadFiltered:
            'Daten werden gefiltert heruntergeladen. Alle verfügbaren Tabellenspalten sind in den Daten für Excel enthalten.',
          excelDownloadUnFiltered:
            'Alle Daten werden ungefiltert heruntergeladen. Alle verfügbaren Tabellenspalten sind in den Daten für Excel enthalten.',
          excelDownloadReadOnly:
            'Daten werden gefiltert und schreibgeschützt heruntergeladen. Alle verfügbaren Tabellenspalten sind in den Daten für Excel enthalten.',
        },
      },
    },
    upload: {
      zipUploadModal: {
        headline: 'Dokumente hochladen',
      },
      title:
        'Ziehen Sie Dateien per Drag-and-Drop hierher oder klicken Sie, um ',
      subtitle: 'Dateien auszuwählen.',
      permittedFormats: 'Zulässige Dateiformate',
      maxSize: 'Maximale Dateigröße',
      maxUploads: 'Maximale Dateianzahl',
      upload: 'Hochladen',
      uploadDocuments: 'Dokumente hochladen',
      uploading: 'Wird hochgeladen',
      cancel: 'Abbrechen',
      close: 'Schließen',
      okay: 'Okay',
      uploadFailed: 'Upload fehlgeschlagen',
      rejected: 'Abgelehnte Dateien',
      addedToUpload: 'Hinzugefügte Dateien',
      fileSummary_one: '{{ count }} Datei | {{ totalFileSize }}',
      fileSummary_other: '{{ count }} Dateien | {{ totalFileSize }}',
      info: {
        progress_one:
          '{{ count }} von {{ total }} Dateien wurde erfolgreich hochgeladen.',
        progress_other:
          '{{ count }} von {{ total }} Dateien wurden erfolgreich hochgeladen.',
        problemCount_one: 'Es gab ein Problem bei {{ count }} Datei.',
        problemCount_other: 'Es gab ein Problem bei {{ count }} Dateien.',
      },
      uploadedFiles: 'Hochgeladene Dateien',
      conditionalFilterOptionsError:
        'Beim Laden der Metadaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      uploadZip: 'ZIP-Archiv hochladen',
      back: 'Zurück',
      extractMetaData: {
        title: 'Metadaten aus dem Dokument gelesen',
        checkBtnLabel: 'Dateispezifische Metadaten überprüfen',
        fileName: 'Dateiname',
        size: 'Dateigröße',
        totalFiles_one:
          'Metadaten von {{ success }} von {{ count }} Dateien wurden erfolgreich gelesen.',
        totalFiles_other:
          'Metadaten von {{ success }} von {{ count }} Dateien wurden erfolgreich gelesen.',
        failedToExtract_one:
          'Beim Festlegen der Metadaten für {{ count }} Datei ist ein Fehler aufgetreten.',
        failedToExtract_other:
          'Beim Festlegen der Metadaten für {{ count }} Dateien ist ein Fehler aufgetreten.',
        readFromDocument: 'Aus Dateinamen lesen',
      },
      noFiles: 'Keine Dateien zum Hochladen',
      hideAndSelectAllFieldError:
        'Das Feld {{title}} ist als „Alle ausblenden und auswählen“ konfiguriert, was nur maximal 10 Elemente unterstützt.',
    },
    backToPage: 'Zurück zur Seite',
    forms: {
      validationErrors: {
        inputIsRequired: 'Eingabe benötigt',
        minMaxNumberError: 'Erwartet {{expected}}',
        minDateError: 'Das Datum darf nicht vor ',
        maxDateError: 'Datum darf nicht nach dem ',
        shouldBeMaxError:
          'Das Maximum aller Teilverkäufe sollte nicht vor dem Ausstiegsdatum liegen.',
      },
    },
    updateTableRow: {
      title_one: 'Eintrag bearbeiten ({{count}} Artikel)',
      title_other: 'Einträge bearbeiten ({{count}} Artikel)',
      titleForTypeDoc_one: 'Dokument bearbeiten ({{count}} Element)',
      titleForTypeDoc_other: 'Dokumente bearbeiten ({{count}} Elemente)',
      updateError: 'Fehler beim Aktualisieren von {{errorRowCount}} Elementen',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
    },
    navigation: {
      dynamicNavSection: {
        title: 'Detail-Seiten',
        closeAll: 'Alle schließen',
        errorNotification: 'Fehler beim Schließen der Detailseiten-Links!',
      },
    },
    initFundOperation: {
      title: 'Fund Operation erstellen',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
      successMessage: 'Die Fund Operation wurde erfolgreich erstellt.',
      fundLoadingError:
        'Beim Laden der Funddaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      currencyLoadingError:
        'Beim Laden der Währungsdaten ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      error:
        'Es ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
    },
    createRow: {
      title: 'Zeile erstellen',
      successMessage: 'Die Zeile wurde erfolgreich erstellt.',
      error:
        'Es ist ein Systemfehler aufgetreten. Bitte brechen Sie den Vorgang ab und versuchen Sie es erneut.',
      fileUploadRequired: 'Es muss mindestens eine Datei ausgewählt werden.',
      cancel: 'Abbrechen',
      submit: 'Abschicken',
      okay: 'Okay',
      submitting: 'Wird abgeschickt',
    },
    tableSidebarWidget: {
      closeSidebar: 'Sidebar schließen',
      download: 'Download',
      noDocumentsAvailable: 'Keine Dokumente verfügbar',
      openInPage: 'In Dokumente öffnen',
      widgetTitle: 'Details',
      errorText:
        'Beim Laden der zugehörigen Dokumente ist ein Problem aufgetreten.',
    },
    vegaChartWidget: {
      groupingError:
        'Für die Datenspalten ist keine Spaltengruppierung konfiguriert',
    },
  },
} as const;

export default de;
